<template>
  <div data-component="Widget/ControlPoint">
    <input 
      type="radio" 
      :name="name" 
      :id="id" 
      :value="value"
      :checked="checked"
      :required="required"
      :disabled="readOnly"
      @change="handleChange"
    />
    <label :for="id">{{ label }}</label>
  </div>
</template>

<script>
export default {
  name: 'ControlPoint',
  props: {
    label: {
      type: String,
      required: true
    },
    name: {
      type: String,
      required: true
    },
    id: {
      type: String,
      required: true
    },
    value: {
      type: [String, Number],
      default: ''
    },
    checked: {
      type: Boolean,
      default: false
    },
    required: {
      type: Boolean,
      default: false
    },
    readOnly: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    handleChange(event) {
      this.$emit('change', event)
    }
  }
}
</script>

<style lang="scss" scoped>
/* Styles globaux dans src/assets/styles/components/Widget.scss */
</style>
